// dependencies
import { useState } from "react";
import { useDispatch } from "react-redux";
import { GenerateProcess } from "redux-process";

import useInterval from "../../../hooks/useInterval";
// hooks
import useSubscribe from "../../../hooks/useSubscribe";

// actions
import { UpdateJobs } from "../../../actions/jobs.actions";

// utils
import pubSub from "../../../utils/PubSub";

/**
 * This component is responsible for handling
 * async jobs when websockets don't work.
 * It uses a default frequency of calls of 20 seconds.
 * It will switch to a higher frequency of 0.5 seconds
 * when there is an active async job.
 *
 * useSubscribe hook is used to listen to when frequency
 * should be dialed up or down.
 *
 * useInterval hook is used to take the frequency and
 * call the async job status endpoint
 * @returns {null}
 * @constructor
 */
const TaskRunnerFallback = () => {
	const dispatch = useDispatch();
	const [asyncFrequency, setAsyncFrequency] = useState(20000);

	useSubscribe("check async frequency", (data) => {
		setAsyncFrequency(data.frequency);
	});

	const getAsyncTasks = async () => {
		const request = await dispatch(GenerateProcess("GetAsyncTasks"));
		const latestAsyncTasks = request.response.data ? request.response.data : [];
		dispatch(UpdateJobs(latestAsyncTasks));

		if (latestAsyncTasks.length === 0 && asyncFrequency !== 20000) {
			pubSub.publish("check async frequency", { frequency: 20000 });
		} else if (latestAsyncTasks.length > 0 && asyncFrequency !== 500) {
			pubSub.publish("check async frequency", { frequency: 500 });
		}
	};

	useInterval(getAsyncTasks, asyncFrequency);

	return null;
};

export default TaskRunnerFallback;
